module.exports = __webpack_public_path__ + "img/business-background-backgrounds-business-1-5c9b8f75536e8.42cee682.png";